/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForDimensionGraphDBSync extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForDimensionGraphDBSync");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForDimensionGraphDBSync.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForDimensionGraphDBSync>): BackgroundJobPayloadForDimensionGraphDBSync {
        let obj = Object.assign(new BackgroundJobPayloadForDimensionGraphDBSync(), model);
        BackgroundJobPayloadForDimensionGraphDBSync.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForDimensionGraphDBSync>): BackgroundJobPayloadForDimensionGraphDBSync {
        if (!model) return null;
        return BackgroundJobPayloadForDimensionGraphDBSync.newInstance(<BackgroundJobPayloadForDimensionGraphDBSync> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForDimensionGraphDBSync) {
        if (!obj) return;

        models.BackgroundJobPayloadForDimensionGraphDBSync.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForDimensionGraphDBSync): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForDimensionGraphDBSync.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * CoreStack master account whose Dimension data is (re)projected into GraphDB (repo + named-graph scope).
     */
    master_account_id: string;

}
